module.exports = __webpack_public_path__ + "img/minus-circle.3df54807.svg";